import React from 'react';
import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded.js';
import EventRoster from "../../src/eventRoster/EventRoster.js";

ReactDOM.render(
  <EventRoster
    childrenAndMember={preloaded.user_children_and_user}
    admin={preloaded.game_admin}
    homeTeam={preloaded.home_team}
    awayTeam={preloaded.away_team}
    initialTeam={preloaded.initial_team}
    href={preloaded.game}
  />,
  document.getElementById("GameRoster")
);

